module.exports = __webpack_public_path__ + "media/images/emblems/Degersheim-coat_of_arms-f49c073c58debeb2e4ee0ea99961a676.svg";